module.exports = __webpack_public_path__ + "img/logo.558a3d76.png";